<main
    class="agpr-targetingSearch"
    *ngIf="targetingSearch"
    [agprLoading]="loading"
    [formGroup]="searchForm"
>
    <section class="agpr-targetingSearch-center" [attr.aria-label]="'Common.layout.main' | localize">
        <div class="agpr-targetingSearch-centerToolbar">
            <header>
                <h2
                    class="agpr-targetingSearch-header"
                    [ngClass]="{'agpr-targetingSearch-header--visible': targetingSearch.id}"
                >
                    @if (targetingSearch.id) {
                        <span class="agpr-targetingSearch-name">{{ targetingSearch.name }}</span>
                    }

                    <span class="u-srOnly">{{ 'Discover.targeting.search' | localize }}</span>
                </h2>
            </header>
            <agpr-tabs
                class="agpr-targetingSearchTabs"
                [selectedTabIndex]="selectedTabIndex"
                (selectedTabIndexChange)="tabChange($event)"
            >
                <agpr-tab
                    [icon]="'fa-regular fa-duotone fa-user'"
                    [heading]="'Discover.targeting.search.mode.contact'"
                    [id]="'targetingSearch_contactTab'"
                >
                </agpr-tab>
                <agpr-tab
                    [icon]="'fa-kit-duotone fa-agpr-outlet'"
                    [heading]="'Discover.targeting.search.mode.outlet'"
                    [id]="'targetingSearch_outletTab'"
                >
                </agpr-tab>
            </agpr-tabs>
        </div>
        <agpr-scroll-panel>
            <div class="agpr-targetingSearch-centerForm">
                @if (targetingSearch.searchMode === searchModes.contact) {
                    <agpr-contact-search
                        (formReady)="addChildForm('contactForm', $event)"
                        [contactData]="targetingSearchFull"
                        (valueChange)="updateSearch($event)"
                    ></agpr-contact-search>
                } @else if (targetingSearch.searchMode === searchModes.outlet) {
                    <agpr-outlet-search
                        (formReady)="addChildForm('outletForm', $event)"
                        [outletData]="targetingSearchFull"
                        (valueChange)="updateSearch($event)"
                    ></agpr-outlet-search>
                }
            </div>
        </agpr-scroll-panel>

        @if (noSearchParameter && showError) {
            <agpr-form-message>
                {{ 'Discover.targeting.actions.search.parameterRequired' | localize }}
            </agpr-form-message>
        }

        @if (hasUnavailableOutlet) {
            <div
                class="agpr-targetingSearch-center-warningMessage"
            >
                <agpr-message
                    [severity]="messageSeverityEnum.warning"
                    [closeable]="true"
                >
                    <span>
                        {{
                            "Discover.targeting.search.warningMessage.outlet.content"
                                | localize
                        }}
                    </span>
                </agpr-message>
            </div>
        }

        <agpr-action-bar
            [headingContext]="'Monitoring.search.search' | localize"
        >
            <ng-template #left>
                @if (searchDirty) {
                    <agpr-button
                        id="targetingSearch_restoreCachedSearch"
                        label="Discover.targeting.actions.reset"
                        [style]="buttonTypes.secondary"
                        (click)="restoreCachedSearch()"
                    ></agpr-button>
                }
            </ng-template>
            <ng-template #right>
                @if (searchDirty && targetingSearch.id) {
                    <agpr-split-button
                        id="targetingSearch.saveChangesOrSaveAsNew"
                        [label]="'Discover.targeting.actions.save' | localize"
                        [options]="saveActions"
                        [disabled]="previewCount >= MAX_SEARCH_SIZE || previewLoading || !searchForm.valid"
                        [panelPositionY]="'top'"
                        [panelPositionX]="'right'"
                        [style]="buttonTypes.primaryB"
                    ></agpr-split-button>
                } @else if (searchDirty && !targetingSearch.id) {
                    <agpr-button
                        id="targetingSearch.saveTargetingSearch"
                        label="Discover.targeting.actions.saveSearch"
                        [disabled]="previewCount >= MAX_SEARCH_SIZE || previewLoading || !searchForm.valid"
                        (click)="openCreateDialog()"
                        [style]="buttonTypes.primaryB"
                    ></agpr-button>
                }

                @if (false) {
                    <agpr-button
                        id="targetingSearch.recommendedRecipientSearch"
                        label="Discover.targeting.actions.recommendedRecipientDebugSearch"
                        [style]="buttonTypes.primary"
                        tooltipPosition="top"
                        ariaDescribedBy="targetingSearch.search_disabledMessage"
                        (click)="recommendedRecipientSearch()"
                    ></agpr-button>
                }

                <agpr-button
                    id="targetingSearch.search"
                    [label]="'Discover.targeting.actions.search' | localize : {
                        count: previewCountString
                    }"
                    [ariaLabel]="'Discover.targeting.actions.search' | localize : {
                        count: previewCountString
                    }"
                    [loading]="previewLoading"
                    [style]="buttonTypes.primary"
                    [disabled]="previewCount >= MAX_SEARCH_SIZE || previewLoading || !searchForm.valid"
                    [tooltip]="previewCount >= MAX_SEARCH_SIZE
                                ? 'Discover.targeting.actions.search.searchTooBroad'
                                : ''"
                    tooltipPosition="top"
                    ariaDescribedBy="targetingSearch.search_disabledMessage"
                    (click)="navigateToSearchResults()"
                ></agpr-button>
                <span id="targetingSearch.search_disabledMessage" class="u-srOnly">
                    {{ previewCount >= MAX_SEARCH_SIZE
                        ? ('Discover.targeting.actions.search.searchTooBroad' | localize)
                        : null
                    }}
                </span>
            </ng-template>
        </agpr-action-bar>
    </section>
    <aside
        class="agpr-targetingSearch-sidebar"
        [attr.aria-label]="'Common.layout.rhp' | localize"
        formGroupName="general"
    >
        <agpr-right-sidebar>
            <agpr-tab
                [id]="'targetingSearchSliders'"
                icon=" fa-sliders"
                tooltip="Monitoring.search.rhp.setup"
            >
                <agpr-panel
                    header="Discover.targeting.panels.searchRefinements"
                    [isFormGroup]="true"
                >
                    <div class="agpr-targetingSearch-secondaryField">
                        <agpr-include-exclude-chips
                            formControlName="mediaTypes"
                            id="targetingSearch.mediaTypes"
                            headerLabel="Discover.targeting.searchFieldLabels.mediaTypes"
                            [placeholder]="'Discover.targeting.searchFieldLabels.select.placeholder'"
                            [optionsFetcher]="journodexEnumsService.getMediaTypes()"
                            keyLookupField="enumValue"
                            labelLookupField="displayString"
                            [showIncludeAll]="true"
                            [tooltipPath]="'Discover.targeting.definition.media.'"
                            itemTooltipPosition="left"
                            headingLevel="5"
                        ></agpr-include-exclude-chips>

                        <agpr-include-exclude-chips
                            formControlName="productTypes"
                            id="targetingSearch.productTypes"
                            headerLabel="Discover.targeting.searchFieldLabels.productTypes"
                            [placeholder]="'Discover.targeting.searchFieldLabels.select.placeholder'"
                            [optionsFetcher]="journodexEnumsService.getProductTypes()"
                            keyLookupField="enumValue"
                            labelLookupField="displayString"
                            [showIncludeAll]="false"
                            [tooltipPath]="'Discover.targeting.definition.product.'"
                            itemTooltipPosition="left"
                            headingLevel="5"
                        ></agpr-include-exclude-chips>

                        @if (incompatibleProductTypes.length > 0) {
                            <agpr-message
                                [severity]="messageSeverityEnum.warning"
                                class="agpr-targetingSearch-incompatibleProductTypeWarning"
                            >
                                <p>{{ 'Discover.targeting.searchFieldLabels.productTypes.incompatibilityWarning.line1' | localize }}</p>
                                <ul
                                    *ngFor="let incompatibleProductType of incompatibleProductTypes"
                                    class="agpr-targetingSearch-incompatibleProductTypeWarning-list"
                                >
                                    <li>{{ incompatibleProductType }}</li>
                                </ul>
                                <p>{{ 'Discover.targeting.searchFieldLabels.productTypes.incompatibilityWarning.line2' | localize }} <a
                                    href="http://help.agilitypr.com/en/articles/5409399-understanding-media-product-types" target="_blank"
                                    class="agpr-targetingSearch-incompatibleProductTypeWarning-link">
                                    {{ 'Discover.targeting.actions.learnMore' | localize }}</a>.</p>
                            </agpr-message>
                        }

                        <agpr-include-exclude-chips
                            formControlName="marketSectors"
                            id="targetingSearch.marketSectors"
                            headerLabel="Discover.targeting.searchFieldLabels.marketSectors"
                            [placeholder]="'Discover.targeting.searchFieldLabels.select.placeholder'"
                            [optionsFetcher]="journodexEnumsService.getMarketSectors()"
                            keyLookupField="enumValue"
                            labelLookupField="displayString"
                            [showIncludeAll]="false"
                            [tooltipPath]="'Discover.targeting.definition.marketSectors.'"
                            itemTooltipPosition="left"
                            headingLevel="5"
                        ></agpr-include-exclude-chips>

                        <agpr-include-exclude-chips
                            formControlName="coverageFocuses"
                            id="targetingSearch.coverageFocuses"
                            headerLabel="Discover.targeting.searchFieldLabels.coverageFocuses"
                            [placeholder]="'Discover.targeting.searchFieldLabels.select.placeholder'"
                            [optionsFetcher]="journodexEnumsService.getCoverageFocuses()"
                            keyLookupField="enumValue"
                            labelLookupField="displayString"
                            [showIncludeAll]="false"
                            [tooltipPath]="'Discover.targeting.definition.coverageFocus.'"
                            itemTooltipPosition="left"
                            headingLevel="5"
                        ></agpr-include-exclude-chips>

                        <agpr-include-exclude-chips
                            formControlName="productFrequencies"
                            id="targetingSearch.productFrequencies"
                            headerLabel="Discover.targeting.searchFieldLabels.productFrequencies"
                            [placeholder]="'Discover.targeting.searchFieldLabels.select.placeholder'"
                            [optionsFetcher]="journodexEnumsService.getProductFrequencies()"
                            keyLookupField="enumValue"
                            labelLookupField="displayString"
                            [showIncludeAll]="false"
                            [tooltipPath]="'Discover.targeting.definition.publicationFrequencies.'"
                            itemTooltipPosition="left"
                            headingLevel="5"
                        ></agpr-include-exclude-chips>

                        <agpr-include-exclude-chips
                            formControlName="targetAudiences"
                            id="targetingSearch.targetAudiences"
                            headerLabel="Discover.targeting.searchFieldLabels.targetAudiences"
                            [placeholder]="'Discover.targeting.searchFieldLabels.select.placeholder'"
                            [optionsFetcher]="journodexEnumsService.getTargetAudiences()"
                            keyLookupField="enumValue"
                            labelLookupField="displayString"
                            [showIncludeAll]="true"
                            [tooltipPath]="'Discover.targeting.definition.targetAudiences.'"
                            itemTooltipPosition="left"
                            headingLevel="5"
                        ></agpr-include-exclude-chips>
                    </div>

                    <div
                        role="group"
                        aria-labelledby="targetingSearch.audienceReach"
                        class="agpr-targetingSearch-filterContainer"
                    >
                        <label
                            id="targetingSearch.audienceReach"
                            class="agpr-targetingSearch-reachFilter-headerLabel"
                        >
                            {{ 'Discover.targeting.filter.audienceReach' | localize }}
                        </label>
                        <div class="agpr-targetingSearch-reachFilter">
                            <div class="agpr-targetingSearch-reachFilter-dropdown">
                                <agpr-dropdown
                                    formControlName="audienceReachType"
                                    [id]="'targetingSearch_audienceReach_dropdown'"
                                    [options]="circulationTypeOptions"
                                    placeholder="Discover.targeting.searchFieldLabels.select.placeholder"
                                    ariaLabel="Discover.targeting.filter.audienceReach"
                                ></agpr-dropdown>
                            </div>

                            <div class="agpr-targetingSearch-reachFilter-grid">
                                <agpr-number-input
                                    formControlName="audienceReachMin"
                                    [id]="'reachFilter.min'"
                                    [min]="reachMinimum"
                                    [max]="!!audienceReachMax.value ? audienceReachMax.value : reachMaximum"
                                    [integerOnly]="true"
                                    [forceMinValue]="false"
                                    labelIcon="fa-solid fa-angle-right"
                                    [label]="'Common.filter.range.minimum' | localize"
                                ></agpr-number-input>
                                <agpr-number-input
                                    formControlName="audienceReachMax"
                                    [min]="!!audienceReachMin.value ? audienceReachMin.value : 0"
                                    [id]="'reachFilter.max'"
                                    [max]="reachMaximum"
                                    [integerOnly]="true"
                                    [forceMinValue]="false"
                                    labelIcon="fa-solid fa-angle-left"
                                    [label]="'Common.filter.range.maximum' | localize"
                                ></agpr-number-input>
                            </div>
                        </div>
                    </div>

                    @if (targetingSearch.searchMode === searchModes.contact) {
                        <div
                            role="group"
                            aria-labelledby="targetingSearch.include"
                            class="agpr-targetingSearch-filterContainer"
                        >
                            <label
                                id="targetingSearch.include"
                                class="agpr-targetingSearch-secondaryFieldLabels"
                            >
                                {{ 'Discover.targeting.searchFieldLabels.include' | localize }}
                            </label>
                            <div class="agpr-targetingSearch-includesArea">
                                <agpr-checkbox
                                    formControlName="includePrivateContacts"
                                    id="targetingSearch_includes_privateContacts"
                                    label="Discover.targeting.searchFieldLabels.privateContacts"
                                    [binary]="true"
                                ></agpr-checkbox>
                                <agpr-checkbox
                                    formControlName="groupByOutlet"
                                    id="targetingSearch_groupByOutlet"
                                    label="Discover.targeting.searchFieldLabels.groupByOutlet"
                                    [binary]="true"
                                ></agpr-checkbox>
                            </div>
                        </div>
                    }

                </agpr-panel>
            </agpr-tab>
            <agpr-tab
                [id]="'targetingSearchSummary'"
                icon=" fa-file-lines"
                tooltip="Monitoring.search.rhp.summary"
                [showSpacer]="true"
            >
                <agpr-targeting-search-summary
                    [targetingSearch]="targetingSearch"
                ></agpr-targeting-search-summary>
            </agpr-tab>
        </agpr-right-sidebar>
    </aside>
</main>
